import { AxiosResponse } from 'axios';
import { leagueDailyCoverageExport, leagueDailyCoverageList } from '@/api/leagueDailyCoverage';
import { AppError } from '@/errors/appError';
import { baseListExportService, baseListService, isRequestCanceled } from '@/services/baseService';
import { ILeagueDailyCoverageApiListResponse, ILeagueDailyCoverageFilters } from '@/types/leagueDailyCoverage';
import { IListParams } from '@/types/service';

export const leagueDailyCoverageService = {
    async list(params: IListParams<ILeagueDailyCoverageFilters>): Promise<AxiosResponse<ILeagueDailyCoverageApiListResponse>> {
        try {
            return await baseListService<ILeagueDailyCoverageApiListResponse>(leagueDailyCoverageList, params);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('League Daily Coverage API Error:', e);
            throw new AppError('Unable to load league daily coverage list, request error', { cause: e });
        }
    },

    async export(params: IListParams<ILeagueDailyCoverageFilters | Record<string, any>>): Promise<AxiosResponse<Blob>> {
        try {
            return await baseListExportService(leagueDailyCoverageExport, params);
        } catch (e) {
            console.error('League Daily Coverage Export API Error:', e);
            throw new AppError('Unable to export league daily coverage, request error', { cause: e });
        }
    },
};
